import React from "react";
import { useNavigate } from "react-router-dom";
import PageShell from "../components/PageShell";
import { SparklesIcon } from "../components/Icons";
import "./SelectFestival.css";

const SelectFestival = () => {
  const navigate = useNavigate();

  const festivals = [
    "Christmas",
    "New Year",
    "Thanksgiving",
    "Easter",
    "Diwali",
    "Hanukkah",
    "Eid",
    "Chinese New Year",
    "Halloween",
    "Valentine's Day",
    "Independence Day",
    "Labor Day",
  ];

  return (
    <PageShell
      title="Select an Occasion"
      subtitle="Choose an occasion to generate an AI-assisted greeting card."
      actions={
        <div className="festivalTitleIcon">
          <SparklesIcon className="festivalTitleIconSvg" />
        </div>
      }
    >
      <div className="festivalGrid">
        {festivals.map((name) => (
          <button
            key={name}
            className="festivalCard"
            onClick={() =>
              navigate(`/greeting-card/${encodeURIComponent(name.toLowerCase().replace(/\s+/g, "-"))}`)
            }
            type="button"
          >
            <div className="festivalCard__icon">
              <SparklesIcon className="festivalCard__iconSvg" />
            </div>
            <div className="festivalCard__name">{name}</div>
          </button>
        ))}
      </div>
    </PageShell>
  );
};

export default SelectFestival;
